import PropTypes from 'prop-types';
import React from 'react';
import '../../styles/EmojiPanel.scss';
import data from './EmojiData.js';
import {emojiReplaceNodeChildren, shouldReplaceWithEmojiImg} from '../../utils/emojiUnicodeToImage';

class EmojiPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: '0'
    };
  }

  componentDidMount() {
    if (shouldReplaceWithEmojiImg()) {
      emojiReplaceNodeChildren(this.panel);
    }
  }

  createEmoji(unicode) {
    if (Array.isArray(unicode)) {
      return String.fromCodePoint('0x' + unicode[0], '0x' + unicode[1]);
    }
    return String.fromCodePoint('0x' + unicode);
  }

  isActive(index) {
    return this.state.activeTab === index.toString();
  }

  setActiveTab(index) {
    this.setState({activeTab: index.toString()});
  }

  buildTab(category, index) {
    const filteredEmojies = shouldReplaceWithEmojiImg() ? category.emojis.filter(emojiData => !emojiData.filter) : category.emojis;

    return (<div key={index} className={this.isActive(index) ? 'active' : ''}>
      {filteredEmojies.map((emojiData, index) => {
        const emoji = this.createEmoji(emojiData.unicode);
        const unicode = emojiData.unicode.toString();
        return (
          <span data-unicode={unicode} onClick={() => this.props.onEmojiClick(emoji, unicode)} key={index}>
            {emoji}
          </span>);
      })
      }
    </div>);
  }

  render() {
    return (
      <div ref={panel => this.panel = panel} className="emoji-panel">
        <div className="categories">
          {data.map((category, index) =>
            <span
              key={index}
              onClick={() => this.setActiveTab(index)}
              className={`${category.class} ${this.isActive(index) ? 'active' : ''}`}
              >
              {category.icon ? this.createEmoji(category.icon) : null}
            </span>
          )}
        </div>
        <div className="inner-panel">
          {data.map((category, index) => this.buildTab(category, index))}
        </div>
      </div>
    );
  }
}

EmojiPanel.propTypes = {
  onEmojiClick: PropTypes.func
};

export default EmojiPanel;



// WEBPACK FOOTER //
// ./chat-app/components/EmojiPanel/EmojiPanel.js